export default class StatsCountRenderer {
  eGui

  init(params) {
    const divMain = document.createElement('div')
    const divTitle = document.createElement('div')
    const divForGraph = document.createElement('div')
    const div1 = document.createElement('div')
    const div2 = document.createElement('div')
    divMain.style.height = '100px'
    divForGraph.style.height = '80px'
    divForGraph.style.marginTop = '20px'
    div2.style.backgroundColor = '#017ac3'
    divForGraph.style.width = '100px'
    const fourago = (Number(params.data.fourago)) ? Number(params.data.fourago) : 0
    const threeago = (Number(params.data.threeago)) ? Number(params.data.threeago) : 0
    const twoago = (Number(params.data.twoago)) ? Number(params.data.twoago) : 0
    const oneago = (Number(params.data.oneago)) ? Number(params.data.oneago) : 0
    const current = (Number(params.data.current)) ? Number(params.data.current) : 0
    let column = current
    if (params.colDef.field === 'twoago') {
      column = twoago
    } else if (params.colDef.field === 'oneago') {
      column = oneago
    } else if (params.colDef.field === 'threeago') {
      column = threeago
    } else if (params.colDef.field === 'fourago') {
      column = fourago
    }
    div1.style.position = 'relative'
    div1.style.bottom = '20px'
    const allCount = twoago + oneago + current + threeago + fourago
    div1.innerHTML = (column) || '-'
    div1.style.height = `${((1 - column / allCount) * 80 > 20) ? (1 - column / allCount) * 80 : 20}px`
    div2.style.height = `${((column / allCount) * 80 > 60) ? 60 : (column / allCount) * 80}px`
    divForGraph.appendChild(div1)
    divForGraph.appendChild(div2)
    divMain.appendChild(divTitle)
    divMain.appendChild(divForGraph)
    this.eGui = divMain
  }

  getGui() {
    return this.eGui
  }
}
